import React from 'react'
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import Stack from "@mui/material/Stack"
import Button from "@mui/material/Button"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import {setDrawerOpen} from "../Drawer/slice"
import {useSelector, useDispatch} from "react-redux"
import SearchInput from "../SearchInput"
import Box from '@mui/material/Box'

function SearchBar() {

    const drawerOpen = useSelector(state => (state.drawer.drawerOpen))
    const dispatch = useDispatch()

    return (
        <AppBar
            position={`static`}
            sx={{
                display: {xs: 'none', md: 'block'},
                width: '100%',
                bgcolor: 'white',
                padding: 2,
                margin: 0
            }}
        >
            <Toolbar>
                <SearchInput/>
                <Stack
                    sx={{
                        display: {xs: "block", md: 'none'},
                        marginLeft: 'auto'
                    }}
                    direction='row'
                    spacing={2}
                >
                    <Button
                        variant='text'
                        startIcon={<FilterAltIcon/>}
                        onClick={() => {
                            dispatch(setDrawerOpen(!drawerOpen))
                        }}
                    >
                    </Button>
                </Stack>
            </Toolbar>
        </AppBar>
    )
}

export default SearchBar